module.exports = __webpack_public_path__ + "img/excel_icon.5be91d9f.png";